import { render, staticRenderFns } from "./LoadingFragment.vue?vue&type=template&id=1bba5ce0&scoped=true&"
import script from "./LoadingFragment.vue?vue&type=script&lang=js&"
export * from "./LoadingFragment.vue?vue&type=script&lang=js&"
import style0 from "./LoadingFragment.vue?vue&type=style&index=0&id=1bba5ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba5ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/npm-packages/global-vue-components-commit/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bba5ce0')) {
      api.createRecord('1bba5ce0', component.options)
    } else {
      api.reload('1bba5ce0', component.options)
    }
    module.hot.accept("./LoadingFragment.vue?vue&type=template&id=1bba5ce0&scoped=true&", function () {
      api.rerender('1bba5ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/LoadingFragment.vue"
export default component.exports